import React from 'react';
import classNames from 'classnames';
import cls from './ManagerRow.module.css';
import { useManagerRow } from './useManagerRow';
import { ManagerCardList } from '../../../UI/ManagerCardList/ManagerCardList';

interface ManagerRowProps {
    classes?: string;
}

export const ManagerRow = ({ classes }: ManagerRowProps) => {
    const { onAddManager } = useManagerRow();

    return (
        <div className={classNames(cls.ManagerRow, [classes])}>
            <span className={cls.title}>{i18next.t('ManagerRow.return.title')}</span>
            <div className={cls.managerFlex}>
                <ManagerCardList />
            </div>
        </div>
    );
};
